import type { AccessHistory } from './accessHistory';

export type LanguageSectionId = 'access' | 'benchmarks' | 'assignments';
export type LanguageSection = { id: LanguageSectionId; show: boolean };

export function languageSections({ accessKind, usesFlashlight }: { accessKind: AccessHistory['kind']; usesFlashlight: boolean }): LanguageSection[] {
  return [
    { id: 'access', show: accessKind !== 'none' },
    { id: 'benchmarks', show: true },
    { id: 'assignments', show: usesFlashlight },
  ];
}
